import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const submitCustomLabel = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) => {
    const getCreateEntityFromLabel = plugin.config.createCustom?.fromLabel
    if (!getCreateEntityFromLabel) {
      // Cannot do this if custom creation is not enabled
      return
    }
    return feature.actions.submitCustomLabel.relay(forwardTo =>
      feature.selectors.editingCustomLabel.asObservable.pipe(
        // We only want the current value of the custom label and then we nee to
        // complete so the relay can complete
        rxjs.take(1),
        // We need to be in the in the "editing" mode an label should be populated, so we can proceed.
        rxjs.filter(
          (
            editingCustomLabel,
          ): editingCustomLabel is typeof editingCustomLabel & {
            label: string
          } => !!editingCustomLabel?.label,
        ),
        rxjs.map(({ label, selectionTarget }) =>
          forwardTo(
            plugin.collection.plugins.dataOperationPlugin.feature.actions
              .create,
            {
              input: {
                input: getCreateEntityFromLabel(label),
              },
              onSuccess: (innerResult, outerResult, source) => {
                const newEntity = innerResult.response?.[0]
                if (!newEntity) {
                  // If no entity is created, there is no entity to select
                  return
                }
                // Selects the newly created entity
                plugin.collection.plugins.selectionPlugin.applied.actions.putInSelectionLookup
                  .from(source)
                  .dispatch({
                    key: selectionTarget,
                    value: {
                      set: plugin.collection.identify(newEntity),
                    },
                  })
              },
            },
          ),
        ),
      ),
    ).asObservable
  },
)
